/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { GlobalProtectedRoute } from 'framework/authorization';
import { READ_APPLICATION } from 'domain/recruiting/applications/shared/applicationService';
import ApplicationsList from 'domain/recruiting/applications/List';
import { Route } from 'framework/routing';
import { ProtectedRouter } from 'infrastructure/routing';
import { applicationsRouterPath, useApplicationsRoute } from 'domain/recruiting/applications/router';

const ApplicationsRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute } = useApplicationsRoute();

  return (
    <ProtectedRouter>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_APPLICATION}>
              <ApplicationsList />
            </GlobalProtectedRoute>
          }
        />
        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

ApplicationsRouter.getRouterPath = applicationsRouterPath;

export default ApplicationsRouter;
